<template>
    <div>
        <div
            class="org-chart"
            ref="orgchart"></div>

        <design-2021-org-chart-detail-modal-component
            ref="org-chart-detail-modal"
            :skill-tree-in="skillTreeIn"
            @update-node="updateNode">
        </design-2021-org-chart-detail-modal-component>

        <design-2021-org-chart-add-node-modal-component
            ref="org-chart-add-node-modal"
            :skill-tree-in="skillTreeIn"
            @add-node="addNode">
        </design-2021-org-chart-add-node-modal-component>

        <design-2021-skilltree-rubric-management-modal
            v-if="loaded"
            ref="skilltree-rubric-management"
            :skill-tree-in="skillTree">
        </design-2021-skilltree-rubric-management-modal>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-orgchart-component',
    props: ['nodesIn', 'skillTreeIn', 'rubricsIn'],
    data() {
        return {
            skills: this.skillsIn,
            skillTree: null,
            loaded: false,
        };
    },
    methods: {
        orgChart(domEl, nodes) {
            this.$orgChart.templates.ana.field_0 =
                '<g class="node-text" transform="translate(0, -15)">' +
                '<text class="field_0" width="230" text-overflow="multiline" style="font-size: 18px;" fill="#fff" x="125" y="70" text-anchor="middle">{val}</text>' +
                '</g>';

            this.$orgChart.templates.ana.size = [250, 120];
            this.$orgChart.templates.ana.node =
                '<rect class="node-" x="0" y="0" height="{h}" width="{w}" fill="#039BE5" stroke-width="1" stroke="#aeaeae" rx="5" ry="5"></rect>';

            const self = this;
            this.chart = new this.$orgChart(domEl, {
                nodes,
                nodeBinding: {
                    field_0: 'name',
                },
                enableDragDrop: true,
                mouseScrool: this.$orgChart.action.scroll,
                orientation: this.$orgChart.orientation.left,
                nodeMouseClick: this.$orgChart.action.none,
                enableSearch: false,
                nodeMenu: {
                    rubric: {
                        text: this.$t('rubrics.manage_rubrics'),
                        icon: '<i class="fas fa-folder-open"></i>',
                        onClick: function (id) {
                            self.$refs['skilltree-rubric-management'].show(id);
                        },
                    },
                    add: {
                        text: this.$t('common.add'),
                        icon: '<i class="fas fa-plus"></i>',
                        onClick: function (id) {
                            const node = {
                                id: self.nodesIn.length + 1,
                                pid: id,
                                name: '',
                            };

                            self.$refs['org-chart-add-node-modal'].show(node.id, id, node.original_id);
                        },
                    },
                    edit: {
                        text: this.$t('common.edit'),
                        icon: '<i class="fas fa-pencil"></i>',
                        onClick: function (id) {
                            self.$refs['org-chart-detail-modal'].show(id, self.nodesIn, true);
                        },
                    },
                    remove: {
                        text: this.$t('common.delete'),
                        icon: '<i class="fad fa-trash"></i>',
                        onClick: function (id) {
                            self.deleteSkill(id, self.nodesIn);
                        },
                    },
                },
                tags: {
                    overrideMenu: {
                        nodeMenu: {
                            add: {
                                text: this.$t('common.add'),
                                icon: '<i class="fad fa-plus"></i>',
                                onClick: function (id) {
                                    const node = {
                                        id: self.nodesIn.length + 1,
                                        pid: id,
                                        name: '',
                                    };
                                    self.$refs['org-chart-add-node-modal'].show(node.id, id);
                                },
                            },
                        },
                    },
                },
                align: this.$orgChart.ORIENTATION,
            });

            // Disable drag on Root node
            this.chart.on('drop', function (sender, draggedNodeId, droppedNodeId) {
                if (!draggedNodeId || droppedNodeId === undefined) {
                    return;
                }

                if (parseInt(draggedNodeId) === 0) {
                    return false;
                }

                self.updateDragAndDrop(draggedNodeId, droppedNodeId);
            });

            let heightMinus = 100;
            this.chart.on('redraw', function (sender) {
                const allNodesRect = document.querySelectorAll('[node-id] rect');

                for (let i = 0; i < allNodesRect.length; i++) {
                    const allNodeTspans = document.querySelectorAll('[node-id="' + (i + 1) + '"]');
                    heightMinus = 160 - 20 * allNodeTspans.length;

                    let node = document.querySelector('[node-id="' + (i + 1) + '"] rect');
                    node.style.height += 120 - heightMinus;
                    node.style.y += heightMinus;
                    let y = node.style.y;
                    if (i > 0) {
                        node.outerHTML +=
                            '<line x1="125" y1="0" x2="125" y2="' +
                            y +
                            '" stroke="#aeaeae" stroke-width="1px" fill="none"></line>';
                    }
                    const allNodeFields = document.querySelectorAll('[node-id="' + (i + 1) + '"] .node-text');
                    for (let j = 0; j < allNodeFields.length; j++) {
                        allNodeFields[j].setAttribute('transform', 'translate(0,' + (heightMinus - 30) + ')');
                    }
                }
            });
        },

        updateDragAndDrop(original_id, parent) {
            let data = {
                pid: parent,
            };

            this.axios.post(this.routes.skillSkillTreeDrag(original_id), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        deleteSkill(id, nodes) {
            for (const node of nodes) {
                if (node.id === id) {
                    this.alert.saving();

                    this.axios.delete(this.routes.skillSkillTreeDelete(node.skill_id)).then(
                        (response) => {
                            this.alert.success();
                            ords.use('skill').remove(node.skill_id);
                            ords.use('skill_skill_trees').remove(node.skill_id);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );

                    this.chart.remove(id);
                    this.chart.draw();
                }
            }
        },

        updateNode(updateNode) {
            this.alert.saving();

            let data = {
                name: updateNode.name,
            };

            this.axios.post(this.routes.skillSkillTreeupdate(updateNode.skill_id), data).then(
                (response) => {
                    this.alert.success();

                    ords.use('skill').update(response.data);

                    this.chart.updateNode(updateNode);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        addNode(newNode) {
            this.alert.saving();

            let data = {
                title: newNode.name,
            };

            if (newNode.pid) {
                data.parentId = newNode.pid;
            }

            this.axios.post(this.routes.skillSkillTreeStore(newNode.skill_tree_id), data).then(
                (response) => {
                    this.alert.success();

                    this.skillTree.addRelation('skill_skill_trees', response.data);

                    let data = {
                        id: response.data.id,
                        name: newNode.name,
                        pid: response.data.parent_skill_id ? response.data.parent_skill_id : 0,
                        skill_id: response.data.skill_id,
                        skill_tree_id: response.data.parent_skill_id,
                        rubrics: [],
                    };

                    this.chart.addNode(data);
                    this.chart.draw();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    mounted() {
        this.orgChart(this.$refs.orgchart, this.nodesIn);

        if (!this.loaded) {
            ords.use('skill_tree').add(this.skillTreeIn);

            ords.use('skill_tree')
                .with('skill_skill_trees', (skillSkillTreeCallback) => {
                    skillSkillTreeCallback.whereHas('skill');
                    skillSkillTreeCallback.with('skill');
                    skillSkillTreeCallback.with('rubricables', (rubricablesCallback) => {
                        rubricablesCallback.with('rubric');

                        rubricablesCallback.with(
                            'rubricable_skill_level_years',
                            (rubricableSkillLevelYearsCallback) => {
                                rubricableSkillLevelYearsCallback.with(
                                    'school_education_level_skill_trees',
                                    (schoolEducationLevelSkillTreesCallback) => {
                                        schoolEducationLevelSkillTreesCallback.with('school_education_levels');
                                    },
                                );
                            },
                        );
                    });
                })
                .find(this.skillTreeIn.id)
                .subscribe((skilltree) => {
                    this.skillTree = skilltree;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped>
.active {
    background-color: green;
}
</style>
